import { Button } from "@mui/material";

const UnderlineButton = ({ onClick, label, color }) => {
  return (
    <Button
      variant="text"
      sx={{
        textTransform: "none",
        textDecoration: "underline",
        color: color ? color : "primary",
      }}
      size="small"
      onClick={onClick}
    >
      {label}
    </Button>
  );
};

export default UnderlineButton;
